import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['dropdown'];

  connect() {
    if (!this.hasDropdownTarget) return;

    useClickOutside(this, { element: this.dropdownTarget });
  }

  clickOutside(event) {
    if (
      event.target.id !== 'mega-menu' &&
      !Array.from(event.target.classList).some((klass) =>
        [
          'menu-link',
          'mega-menu',
          'mega-menu-link',
          'mega-menu-arrow',
        ].includes(klass),
      )
    ) {
      this.closeAll();
    }
  }

  removeDisplay(event) {
    if (this.hasDropdownTarget) {
      this.closeAll();

      const currentContainer = event.currentTarget.closest(
        "[data-one-dropdown-target='dropdownContainer']",
      );
      const currentDropdown = currentContainer.querySelector(
        "[data-one-dropdown-target='dropdown']",
      );

      this.dropdownTargets.forEach((target) => {
        if (target !== currentDropdown) {
          target.classList.add('hidden');
        } else {
          target.classList.remove('hidden');
        }
      });
    }
  }

  closeAll() {
    const megaMenus = document.querySelectorAll('.mega-menu');
    const menuLists = document.querySelectorAll('.menu-list');
    const hasSubmenuOpens = document.querySelectorAll('.has-submenu-open');
    const submenuOpens = document.querySelectorAll('.submenu-open');

    megaMenus.forEach((el) => {
      if (!el.classList.contains('hidden')) {
        el.classList.add('hidden');
      }
    });

    menuLists.forEach((el) => {
      if (!el.classList.contains('hidden')) {
        el.classList.add('hidden');
      }
    });

    hasSubmenuOpens.forEach((el) => {
      el.classList.remove('has-submenu-open');
    });

    submenuOpens.forEach((el) => {
      el.classList.remove('submenu-open');
    });
  }
}
